module.exports = __webpack_public_path__ + "static/Q1Answer1_Purple_wishmas-97d2f0c0a88afbbdd287f2de3ca7d7b9.jpg";